// Français
export const locale = {
  common: {
    homepage: "Accueil",
    back: "Retour",
    video_not_supported:
      "Désolé, votre navigateur ne supporte pas les vidéos intégrés.",
    detail: "Détails",
    list: "Liste des outils",
    footer: "Un site réalisé par Insaniam",
    displayVideo: "Vidéo en cours de lecture",
    submit: "Envoyer",
    cancel: "Annuler",
    errorOccurred: "Une erreur s'est produite",
    cgu: "CGU",
    browser:
      "Bonjour, Tell me Genius n'est pas disponible sur Internet explorer. Nous vous conseillions d'utiliser Chrome ou un autre navigateur. L'équipe TMG",
    browserAlert: "Attention",
    user: {
      lastname: "Nom",
      firstname: "Prénom",
      email: "Email",
      phone: "Téléphone",
      company: "Entreprise",
      address: "Adresse",
    },
    form: {
      required: "Le champ doit être renseigné.",
      required_field: "Le champ '%{field}' doit être renseigné.",
      max_characters: "Nombre de caractères maximum dépassé (%{max} maximum)",
      email_invalid: "L'adresse mail saisie est invalide.",
      phone_translations: {
        countrySelectorLabel: "Code pays",
        countrySelectorError: "Choisir un pays",
        phoneNumberLabel: "Numéro de téléphone",
        example: "Exemple :",
      },
    },
  },
  auth: {
    callback: {
      login: "Genius valide tes accès...",
      logout: "See you soon !",
    },
    errors: {
      invalid_authorizations:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_claims:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_client:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_client_options:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_user:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_user_session:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      invalid_parameters:
        "Authentification non autorisée. Veuillez contacter le support ou un administrateur.",
      empty_user_roles:
        "Rôle ou droits utilisateurs insuffisant. Veuillez contacter le support ou un administrateur.",
      invalid_claims_roles:
        "Rôle ou droits utilisateurs insuffisant. Veuillez contacter le support ou un administrateur.",
      authentication_failed: "Echec de l'authentification. Veuillez réessayer.",
      unknown:
        "Authentification en échec. Veuillez contacter le support ou un administrateur.",
    },
  },
  freemium: {
    quotaReached: {
      title: "Oops.. Tu n'as plus de vidéos disponibles cette semaine.",
      message: "Tu as dépensé ton quota de vidéo pour la semaine, reviens nous voir prochainement pour pouvoir de nouveau regarder des vidéos. Genius te rappelle que tu disposes de <span style='color:#e6057d'>%{videosAuthorized}</span> vidéos tous les <span style=\"color:#e6057d\">%{videosPeriod}</span> jours.",
    },
    banner : {
      message : "Il te reste <span style=\"color:#e6057d\">%{videosLeft}</span> vidéos à voir cette semaine.<br><u>Rappel</u>: tu as <span style=\"color:#e6057d\">%{videosAuthorized}</span> vidéos disponibles tous les <span style=\"color:#e6057d\">%{videosPeriod}</span> jours.",
      button : "Masquer",
    }
  },
  home: {
    api: {
      contact_success: {
        title: "Demande envoyé au génie 📬",
        message:
          "Merci pour nous avoir contacté.<br>L'équipe de TellMeGenius.io revient très prochainement vers toi.",
      },
      contact_failed: {
        title: "Le génie n'a pas pu recevoir ta demande 😢",
        message:
          "Tu peux contacter directement l'équipe TellMeGenius.io à cette adresse : %{mail} ",
        max_attempt:
          "Tu as déjà soumis trop de demande au Genius. 🤯<br>Réessayes ultérieurement.",
      },
      register_success: {
        title: "Plus qu'une étape pour te connecter 🥳",
        message:
          "Tu vas recevoir un e-mail de validation 📬<br>Suis les instructions du mail pour valider la création de ton compte.",
      },
      register_failed: {
        title: "Le Genius n'a pas pu créer ton compte. 😢",
        message:
          "Contactes-nous via notre formulaire pour t'aider à créer ton compte.",
        unknown_error:
          "Une erreur inconnu s'est produite durant l'inscription.<br>Contactes-nous via notre formulaire en bas de page pour t'aider à créer ton compte.",
        recaptcha_token_failed:
          "Les services Google n'ont pas réussi à fournir un token de vérification.<br>Contactes-nous via notre formulaire pour t'aider à créer ton compte.",
        recaptcha_verify_failed:
          "Les services Google ont interdit l'inscription pour non-respect des conditions d'inscription.<br>Contactes-nous via notre formulaire pour t'aider à créer ton compte.",
        wrong_parameters:
          "Les informations renseignées sont incorrectes ou incomplètes.",
        user_already_exist:
          "Il existe déjà un utilisateur avec cette adresse e-mail.Connectes-toi directement ou saisir une autre adresse mail.",
        user_registration_disabled:
          "L'enregistrement de nouveau compte sera possible très prochainement disponible.",
      },
    },
    demo: {
      button: "Teste gratuitement la solution",
    },
    menu: {
      bibliothequeVideos:
        "La page '<span class='text-primary'>Les vidéos</span>' te permet d'accéder à toutes les vidéos disponibles. 📽️<br>Les fonctions de recherche te permettront de trouver la vidéo correspondant à ta question.",
      bibliothequeParcours:
        "La page '<span class='text-primary'>Les parcours</span>' te permet d’accéder aux différents parcours de progression proposés.<br>Ils t’aideront à monter en compétences sur un sujet ou process particulier. 🎓",
      bibliothequeThemes:
        "La page '<span class='text-primary'>Les sujets abordés</span>' t’offre la possibilité de naviguer dans l’ensemble du contenu vidéos ordonné par thèmes: pratique pour trouver la vidéo qui t’aidera sans avoir à formuler de recherche. 🤩",
      posterVideoUser:
        "La page '<span class='text-primary'>Poste tes vidéos</span>' te permet de proposer des vidéos que tu auras toi-même tourné à l’ensemble de ton organisation. Pratique pour mutualiser vos connaissances, non ? 👌",
    },
    popup: {
      video_title: "Découvres gratuitement TellMeGenius.io",
      video_button: "Je m'inscris",
      register_title: "Découvres gratuitement TellMeGenius.io",
      register_message: "Bénéficie de l'ensemble des fonctionnalités et visionne jusqu'à <span style=\"color:#e6057d\">%{videosAuthorized}</span> vidéos par semaine.",
      register_disabled:
        "La création de nouveau compte sera bientôt disponible.<br>Si tu souhaites plus d'informations, contacte-nous via le formulaire en fin de page d'accueil.",
      register_button: "C'est parti",
      register_buton_cancel: "Annuler",
      register_accept_condition_label:
        "J'accepte d'être contacté par les équipes TellMeGenius.io",
      register_accept_condition_mandatory:
        "Vous devez accepter les conditions pour l'inscription",
      tools_selection_label: "Outil(s) portant un intérêt",
    },
    potential: {
      title:
        "Des Systèmes d'Information enfin utilisés à <span class='text-primary font-weight-bold'>100 % de leurs potentiel</span>",
      subtitle_1:
        "TellMeGenius.io rend les systèmes d'informations <span class='text-primary font-weight-bold'>accessibles</span> aux utilisateurs grâce à des <span class='text-primary font-weight-bold'>vidéos pédagogiques</span> réalisées par des experts. 🎥",
      subtitle_2:
        "Les utilisateurs trouvent les réponses à leurs questions sur les outils en moins de 5 minutes, en vidéo, et ce quelle que soit l’étape projet 👇",
      project_support_title: "Accompagnement projet",
      project_support_description:
        "En support des ateliers projet, pour une communication et un partage d’informations optimisés entre l’IT et les métiers",
      operation_support_title: "Support à l’exploitation",
      operation_support_description:
        "Fini la TMA de niveau 1. Une question ? La réponse est accessible en instantané et en toute autonomie par vidéo",
      tool_adoption_title: "Adoption de l’outil",
      tool_adoption_description:
        "Une prise en main sur les nouveaux outils facilitée et un engagement fort des utilisateurs",
      change_management_title: "Conduite du changement",
      change_management_description:
        "Moins de résistance au changement. Les évolutions d’outils ou de process sont assimilées facilement par les utilisateurs",
      training_title: "Formation",
      training_description:
        "Une montée en compétence en autonomie sur les outils",
    },
    tools: {
      title:
        "Quels outils sont traités en <span class='text-primary font-weight-bold'>vidéos</span> ?",
    },
    community: {
      title:
        "Rejoins la <span class='text-primary font-weight-bold'>communauté</span> des Tellers 🚀",
      subtitle_1:
        "Experts sur les Systèmes d'Informations, ils produisent les vidéos et accompagnent dans la réalisation de contenus sur-mesure.",
      subtitle_2:
        "Grands comptes et ETI: ils nous font confiance et maximisent le potentiel de leurs SI grâce à TellMeGenius.io",
    },
    bosco: {
      title: "TellMeGenius.io, une solution Bosco Technologies",
      subtitle_1:
        "Bosco Technologies est spécialisée dans l'expertise EPM. Forts d'années d'expérience en accompagnement des directions finanicières, nous développons aujourd'hui notre activité autour de 3 axes :",
      list_1: "Direction de projet EPM",
      list_2: "Intervention en expertise MOA - MOE EPM",
      list_3: "Edition de solutions d'expertise management",
      star: "Notre étoile du nord ?",
      team: "L'équipe",
    },
    contact: {
      button: "Contacte-nous",
      comment: "Une question ? Un commentaire ? N'hésite pas l'inscrire ici",
      tools: "Les outils/thèmes qui vous intéressent",
    },
  },
  video: {
    player: {
      shortcut: {
        space: "Espace",
        upArrow: "Flèche Haut",
        basArrow: "Flèche Bas",
        rightArrow: "Flèche droite",
        leftArrow: "Flèche gauche",
      },
      play: "Lecture",
      pause: "Pause",
      mute: "Activer le son",
      unmute: "Désactiver le son",
      back: "Retour",
      forward: "Avance",
      pip: "PIP",
      pipNotSupported: {
        title: "Action manuelle sur Firefox requise",
        html: "Genius a besoin de toi pour activer le mode incrustation sur Firefox.<br>Clic droit sur la vidéo, et clic sur 'Regarder en mode incrustation'.",
        button : "<i class='fa fa-thumbs-up'></i> Ok !",
      },
      fullscreen: "Plein écran",
      exitFullscreen: "Quitter le mode plein écran",
      autoplay: {
        label: "Lecture automatique",
        activated: "Lecture automatique activée",
        desactivated: "Lecture automatique désactivée",
      },
      nextVideoMessage: "Prochaine vidéo dans",
      nextVideoSeconds: "seconde(s)",
      resumeMessage: "La vidéo reprend là où tu l'avais laissée",
    },
    otherVideos: "Ceci peut aussi t'intéresser: ",
    courses:
      "Aucun parcours contenant la vidéo | Un parcours contient la vidéo | {count} parcours contenant la video:",
    keyword: "Mots-clés",
    tag: "Aucun tag",
    views: "vues",
    
  },
  theme: {
    selectPlaceholder: "Sélectionne ton outil",
    //page > theme > contentVideo
    title:
      'Aucune vidéo dans le thème "%{param}" | Une vidéo dans le thème "%{param}" | {count} vidéos dans le thème "%{param}"',
    //admin > theme > forms > tabs > themesUser
    subTitle:
      "Aucune vidéo dans l'outil | Une vidéo dans l'outil | {count} vidéos dans l'outil",
    text: "A toi d'explorer !",
    text2: "Aucune vidéo à afficher",
  },
  course: {
    videosInCourse:
      "Aucune vidéo vue sur {total} dans ce parcours | Une vidéo vue sur {total} dans ce parcours | {count} vidéos vues sur {total} dans ce parcours",
    start: "Parcours",
    start2: "commencés",
    nostart: "Parcours",
    nostart2: "à découvrir",
    //page > course > contentVideo
    title:
      'Aucune vidéo dans le parcours "%{param}" | Une vidéo dans le parcours "%{param}" | {count} vidéos dans le parcours "%{param}"',
    videoSuivante: "Vidéo suivante",
    videoPrecedente: "Vidéo précedente",
    all: "Tous les",
    all2: "parcours",
  },
  wish: {
    noSearchResultsL1:
      "Nous n'avons pas trouvé de vidéos correspondant à ta recherche.",
    noSearchResultsL2: "Est-elle complète ? As-tu essayé d'autres mot-clés ?",
    noSatifyingResult: "Aucune vidéo ne correspond à ta recherche ?",
    noSatifyingResultTheme:
      "Aucun thème ou vidéo ne correspond à tes attentes ?",
    noSatifyingVideo: "Cette vidéo ne répond pas à tes attentes ?",
    wish: "Dis-nous ce que tu aurais aimé trouver",
    wishButton: "en cliquant ici",
    placeholderTextArea: "Dis-nous ce que tu aurais aimé trouver.",
    labelAllowContact:
      "J'accepte d’être éventuellement recontacté par les équipes TellMeGenius.io suite à l’envoi de ce message",
    submitWish: "Envoi",
    errors: {
      empty: "Veuillez formuler une demande",
      short:
        "TellMeGenius à besoin d'une demande complète pour permettre d'améliorer son service (min. 30 caractères)",
      exceed: "La demande ne peut pas dépassé 500 caractères",
    },
    submit: {
      title: "Demande au Genius",
      successText:
        "Ton souhait a bien été envoyé au Genius. Il sera analysé très prochainement par lui et ses équipes.",
      errorText:
        "Ton souhait n'a pas pu être envoyé au Genius. Veuillez contacter directement un membre de l'équipe à cette adresse : contact@tellmegenius.io.",
    },
  },
  search: {
    placeholder:
      "Que recherches-tu ? Un mot, une expression, une question, … ?",
    noResults: "Genius n'a pas trouvé de vidéo.",
    noResultsL2: "Ta recherche est-elle complète ?",
  },
  upload: {
    title: "Poste tes propres videos",
    desc1:
      "Poste ici les vidéos que tu souhaites retrouver sur ton compte Tell Me Genius",
    desc2: "Elles ne seront visibles que de tes équipes et toi-même",
    instr1: "Faîtes glisser un fichier ou cliquer ici pour l'ajouter",
    info1: "Extensions supportées :",
    info2: "Taille maximum:",
    info3: "Nom du fichier:",
    info4: "Taille du fichier (bytes):",
    info5: "Extension :",
    send: "Envoyer",
    afterSend: "Fichier ajouté !",
    afterSendOption: "Supprimer",
    mimeTypes: "Veuillez choisir une archive au format .zip.",
    fileMaxSizeError: "Votre archive ne peut dépasser 1 Go",
  },
  sidebar: {
    videosMenu: "Les vidéos",
    coursesMenu: "Les parcours",
    themesMenu: "Les sujets abordés",
    posteVideosMenu: "Poste tes vidéos",
    adminMenu: "Admin",
    actionsRapidesMenu: "Actions rapides",
  },
  sortingMenu: {
    tooltip : "Ordre des vidéos",
    date : "Date",
    view : "Vue",
    alpha : "Alphabétique",
    pertinence: "Pertinence",
    order : {
      asc: "Ordre croissant",
      desc : "Ordre décroissant"
    }
  },
  adminPanel: {
    title: "Panel d'administration",
    content: "Gestion des contenus",
    client: "Gestion des clients",
    clientContent: "Gestion des contenus des clients",
    bosco: "Gestion des comptes Bosco",
    partners: "Gestion des partenaires",
    KPI: "Visualisation des KPI",
    notification: "Gestion des Notifications",
  },
  quickActionsPanel: {
    contentTitle: "Contenu",
    addTheme: "Créer un thème",
    addVideo: "Créer une vidéo",
    addCourse: "Créer un parcours",
    clientTitle: "Clients",
    addClient: "Créer un client",
    addUserRight: "Créer un droit utilisateur",
    addUser: "Créer un utilisateur",
  },
  quickUser: {
    title: "Mon profil",
    firstname: "Prénom",
    name: "Nom",
    client: "Entreprise",
    email: "email",
    logout: "Se déconnecter",
    emailText: "merci d’inscrire ton adresse email ",
    initializeMdp: "Pour modifier ton mot de passe ?",
    reset: "Annuler",
    toolList: "Outil(s)",
    noToolFound: "Aucun outil trouvé",
    contactUs: "Nous contacter",
    role: "Fonction",
    changePassword: "Changer le mot de passe",
  },
  welcome: {
    hello: "Bonjour",
  },
  breadCrumb: {
    dashboard: "Tableau de bord",
  },
  login: {
    welcome: "Bienvenue sur TellMeGenius",
    access: "Accéder à mon compte",
    text: "DEVENEZ EXPERTS DE VOS PROGICIELS !",
    email: "Email",
    password: "Mot de passe",
    passwordConfirm: "Confirmez le mot de passe",
    forgot: "Mot de passe oublié ?",
    forgotText:
      "Merci d’inscrire ton e-mail, tu recevras bientôt un lien te permettant de réinitialiser ton mot de passe.",
    forgotTextQuickUser:
      "Un e-mail t’a été envoyé pour modifier ton mot de passe",
    forgotSuccess:
      "Nous avons bien reçu ta demande suite à l’oubli de ton mot de passe. Si ton e-mail est connu de nos services, un e-mail pour le réinitialiser t’a été envoyé.",
    signIn: "Se connecter",
    continue: "Continuer",
    emailRequired: "L'adresse email est requise",
    passwordRequired: "Le mot de passe est requis",
    confirmPasswordRequired: "Le mot de passe de confirmation est requis",
    passwordsDoesntMath: "Les mots de passes sont différents",
    incorrectData: "Merci de saisir des données valides",
    reset: "Nouveau mot de passe",
    resetText: "Définissez votre nouveau mot de passe",
    tokenIncorrect:
      "Votre demande de ré-initialisation du mot de passe a expirée",
    invalidCredentials: "Identifiants incorrects",
  },
  modal: {
    welcome: "Bienvenue à toi !",
    textModal1:
      "Tu te trouves désormais sur ton espace personnel TellMeGenius.",
    textModal2:
      "Pour commencer, nous t’invitons à visionner le parcours d’initiation",
    textModal3: "qui t’aidera à la prise en main de la plateforme.",
    textModal4: "Il parait même que l’on y a glissé quelques astuces !",
    textModal5:
      "Tu trouveras ce parcours en cliquant sur le bouton ci-dessous.",
    textModal6: "Il se compose de quelques vidéos, que tu pourras visionner",
    textModal7: "consécutivement en cliquant sur «suivant».",
    textModal8: "Bon visionnage, et bonne navigation sur TellMeGenius !",
    click: "C'est parti !",
  },
  404: {
    title: "Oops...Erreur 404",
    text:
      "Nous sommes désolés, la page que vous recherchez n'existe pas ou n'existe plus. ",
  },
  cockpit: {
    summary : {
      title: "Synthèse",
      subtitle: "Vue d'ensemble de l'utilisation de Tellmegenius.io par les membres de votre organisation",
      activeUsers: "Utilisateurs s'étant connectés au moins une fois versus utilisateurs créés",
      connections: "Nombre total de connexions à Tellmegenius.io par vos utilisateurs",
      videoViews: "Nombre total de vidéos vues par vos utilisateurs",
      courseViews: "Nombre total de parcours visionnés en intégralité par vos utilisateurs",
      topUserTitle: "Utilisateur(trice) ayant visionné le plus de contenus",
      topUserViews: "vues vidéos",
    },
    
  },
  editMultipleUserRights: {
    title: "Édition multiple des droits utilisateurs",
    selectedUsers: "Droits utilisateurs sélectionnés",
    themesManagement: "Gestion des Thèmes",
    modifyThemesBtn: "Modifier les thèmes",
    selectedThemesTitle: "Sélection des Thèmes",
    selectedThemes: "Thèmes Sélectionnés",
    selectedCount: "thème(s) sélectionné(s)",
    noThemesSelected: "Aucun thème sélectionné",
    clickToAddThemes: "Cliquez sur \"Modifier les thèmes\" pour ajouter des thèmes",
    associatedRights: "Droits Associés",
    associatedCount: "droit(s) associé(s)",
    noAssociatedRights: "Aucun droit associé à ce thème",
    themeAssociatedSubtitle: "Ce thème sera associé à tous les droits sélectionnés",
    resetBtn: "Réinitialiser",
    validateBtn: "Valider",
    viewAssociatedRights: "Voir les droits associés",
    name: "Nom",
    successUpdate: "Tous les droits utilisateurs ont été modifiés.",
    errorUpdate: "Une erreur est survenue lors de la modification des droits utilisateurs"
  }
  
};
